import { render, staticRenderFns } from "./task-status.vue?vue&type=template&id=81c75962&scoped=true&"
import script from "./task-status.vue?vue&type=script&lang=js&"
export * from "./task-status.vue?vue&type=script&lang=js&"
import style0 from "./task-status.vue?vue&type=style&index=0&id=81c75962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c75962",
  null
  
)

export default component.exports